import { ComponentClass, createContext, useContext } from 'react';

import { DonationCardStateProps } from '@/core/components/DonationCard/DonationCardState';
import type { SeoMeta } from '@/core/types/meta';
import { AdLinkWithStatsApiCallProps } from '@/next/components/Ad/AdLinkWithStatsApiCall';
import { DraggableProps } from '@/next/components/Draggable';
import type { FooterProps } from '@/next/components/Footer/Footer';
import type { HeadProps } from '@/next/components/Head/Head';
import { PreFooterProps } from '@/next/components/PreFooter/PreFooter';
import { RefresherProps } from '@/next/components/Refresher/Refresher';

export interface PageProps extends React.PropsWithChildren {
  noPadding?: boolean;
}

export interface ContentProps extends React.PropsWithChildren {
  scroll?: string;
}

export interface MetaTitleProps {
  meta: SeoMeta;
}

export interface ComponentsContextType {
  Page: React.FC<PageProps>;
  Content: React.FC<ContentProps>;
  AppleButton: React.FC;
  FacebookButton: React.FC;
  GoogleButton: React.FC;
  MetaTitle: React.FC<MetaTitleProps>;
  Footer: React.FC<FooterProps>;
  PreFooter: React.FC<PreFooterProps>;
  Head: React.FC<HeadProps>;
  DonationCardState: React.FC<DonationCardStateProps> | ComponentClass<DonationCardStateProps>;
  Refresher: React.FC<RefresherProps>;
  useBackButton: (handle: () => void) => void;
  AdLinkWithStatsApiCall: React.FC<AdLinkWithStatsApiCallProps>;
  Draggable: React.FC<DraggableProps>;
}

export const ComponentsContext = createContext<ComponentsContextType | null>(null);

export const useComponentsContext = () => useContext(ComponentsContext) as ComponentsContextType;
